import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { OrderForm, ProductCard, Summary } from "./components";
import { AddressBar } from "./components/AddressBar";
import { LunetSpinner } from "./components/LunetSpinner";
import { OrderSubmit } from "./components/OrderSubmit";
import { Step } from "./components/Step";
import { config } from "./lib/config";
import { OrderFormWrapper } from "./lib/contexts/FormikContext";
import { Product, Useplace } from "./lib/types";

function OrderFlow() {
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(0);
  const steps = [
    "Tillgängligt utbud",
    // "Obligatoriska tillvalsprodukter",
    "Kunduppgifter",
    "Sammanställning",
    "Signera",
  ];
  const [selectedProducts, setSelectedProducts] = useState<Product[]>([]);
  const [additionalProducts, setAdditionalProducts] = useState<Product[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const [address, setAddress] = useState<Useplace>();

  const path = useParams();
  console.log(selectedProducts);

  useEffect(() => {
    const fetchProducts = async () => {
      const response = await fetch(
        `${config.API_URL}/order/availableproducts?q=${path.useplaceId}`
      );
      await response
        .json()
        .then((data) => {
          console.log(data);
          setProducts(data.results);
          setAddress(data.useplace);
        })
        .finally(() => {
          setLoading(false);
        });
    };
    fetchProducts();
  }, []);
  useEffect(() => {
    if (selectedProducts.length > 0) {
      // om det inte längre finns måsteprodukter
      const first = selectedProducts[0];
      if (
        (first.required_products && first.required_products.length === 0) ||
        (first.required_products &&
          first.required_products.length !== 0 &&
          additionalProducts.length > 0)
      ) {
        // console.log("Show required products");
        setCurrentStep(1);
        // } else {
        // }else if (){
      }
      // setCurrentStep(1);
    } else if (currentStep > 0) {
      setAdditionalProducts([]);
      setCurrentStep(0);
    }
  }, [selectedProducts, additionalProducts]);

  useEffect(() => {
    if (currentStep > 0) {
      const el = document.querySelector(
        `#step-${currentStep + 1}`
      ) as HTMLDivElement;

      window.scrollTo({
        behavior: "smooth",
        top:
          el.getBoundingClientRect().top -
          document.body.getBoundingClientRect().top -
          200,
        // document.querySelector(selector).getBoundingClientRect().top -
        // document.body.getBoundingClientRect().top -
        // offset,
      });
    }
  }, [currentStep]);
  if (loading) {
    return (
      <div className="w-full text-center">
        <div className="mx-auto relative flex items-center justify-center mt-20">
          {/* <PacmanLoader /> */}
          <LunetSpinner />
        </div>
      </div>
    );
  }

  return (
    <>
      <OrderFormWrapper
        address={address as Useplace}
        products={[...selectedProducts, ...additionalProducts]}
      >
        <AddressBar address={address as Useplace} />

        <div className="mx-4 my-8">
          <div className="max-w-6xl m-auto ">
            <Step idx={1} title={steps[0]} active={currentStep === 0}>
              <div
                className={`grid grid-cols-1 gap-8 ${
                  selectedProducts.length > 0 ? "" : " md:grid-cols-2"
                }`}
              >
                {products &&
                  products.length > 0 &&
                  products.map((product) => (
                    <ProductCard
                      key={product.id}
                      product={product}
                      selectAction={setSelectedProducts}
                      selectedProducts={selectedProducts}
                    />
                  ))}
              </div>
              {selectedProducts.length > 0 &&
                selectedProducts[0].required_products &&
                selectedProducts[0].required_products.length > 0 && (
                  <>
                    {additionalProducts.length === 0 ? (
                      <>
                        <div className="mt-8 mx-auto max-w-2xl mb-4 text-xl text-center">
                          {selectedProducts[0].required_title}
                        </div>
                        <div className="mb-4 mx-auto max-w-2xl text-center">
                          {selectedProducts[0].required_body}
                        </div>
                        <div className="mb-8 mx-auto max-w-2xl text-center">
                          Du behöver välja ett av alternativen nedan.
                        </div>
                      </>
                    ) : (
                      <div className="my-4" />
                    )}
                    <div
                      className={`grid grid-cols-1 gap-8 ${
                        additionalProducts.length > 0 ? "" : " md:grid-cols-2"
                      }`}
                    >
                      {selectedProducts[0].required_products.map((rp) => (
                        <ProductCard
                          key={rp.id}
                          product={rp.product}
                          selectAction={setAdditionalProducts}
                          selectedProducts={additionalProducts}
                          force
                        />
                      ))}
                    </div>
                  </>
                )}
            </Step>
            <Step idx={2} title={steps[1]} active={currentStep === 1}>
              {/* {currentStep === 1 && ( */}
              <OrderForm
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                selectedProducts={selectedProducts}
              />
              {/* )} */}
            </Step>
            <Step idx={3} title={steps[2]} active={currentStep === 2}>
              <Summary
                address={address as Useplace}
                currentStep={currentStep}
                setCurrentStep={setCurrentStep}
                selectedProducts={[...selectedProducts, ...additionalProducts]}
              />
            </Step>
            <Step idx={4} title={steps[3]} active={currentStep === 3}>
              {currentStep === 3 && (
                <div>
                  <div className="border border-gray-300 bg-gray-100 p-12 mb-4">
                    {selectedProducts[0].orderflow_type ===
                    ("installation" || "loan") ? (
                      <>
                        <div className="mb-3">
                          Innan du går vidare med din beställning ber vi dig
                          läsa igenom följande information om ditt avtal samt
                          säkerställa att uppgifterna du angett är korrekta.
                        </div>
                        <div className="mb-3">
                          När du klickar på gå vidare kommer du att komma till
                          vårt digitala avtalshanteringssystem. Där får du:
                        </div>
                        <ul className="mb-3 list-disc pl-6">
                          <li>
                            Ta del av alla avtalsvillkor för den eller de
                            produkter som du valt.
                          </li>
                          <li>
                            Signera avtalet och din beställning med BankID.
                          </li>
                        </ul>
                        <div className="mb-3">
                          Efter att du har signerat kommer våra medarbetare att
                          granska din beställning och säkerställa att vi kan
                          leverera enligt villkor. Det är först när du mottar
                          e-postmeddelandet med din signerade kopia av ditt
                          avtal som vi bekräftat din beställning och avtalet
                          blir juridiskt bindande i enlighet med våra
                          avtalsvillkor.
                        </div>
                        <div className="mb-3">
                          Lunet har möjlighet att annullera din beställning på
                          grund av tekniska problem, när
                          leveransförutsättningarna inte kan uppnås enligt avtal
                          och av liknande skäl.
                        </div>
                        <div className="mb-3">
                          Genom att gå vidare till signering kommer lämnade
                          personuppgifter att behandlas för de ändamål som
                          beskrivs i Lunets Integritetspolicy. För de uppgifter
                          som kräver samtycke lämnas de i samband med att du
                          accepterar Integritetspolicyn.
                        </div>
                      </>
                    ) : null}
                    {selectedProducts[0].orderflow_type === "lime" ? (
                      <>
                        <div className="mb-3">
                          Innan du går vidare ber vi dig läsa igenom följande
                          information om din beställning samt säkerställa att
                          uppgifterna du angett är korrekta.
                        </div>
                        <div className="mb-3">
                          När du skickar din beställning kommer våra medarbetare
                          att granska beställningen samt säkerställa att vi kan
                          leverera och kontakta dig med ett avtalsförslag.
                        </div>
                        <div className="mb-3">
                          Lunet har möjlighet att annullera din beställning på
                          grund av tekniska problem, när
                          leveransförutsättningarna inte kan uppnås och av
                          liknande skäl.
                        </div>
                        <div className="mb-3">
                          Genom att gå vidare kommer lämnade personuppgifter att
                          behandlas för de ändamål som beskrivs i Lunets
                          Integritetspolicy. För de uppgifter som kräver
                          samtycke lämnas de i samband med att du accepterar
                          Integritetspolicyn.
                        </div>
                      </>
                    ) : null}
                  </div>
                  <OrderSubmit
                    selectedProducts={[
                      ...selectedProducts,
                      ...additionalProducts,
                    ]}
                  />
                </div>
              )}
            </Step>
          </div>
        </div>
      </OrderFormWrapper>
    </>
  );
}

export default OrderFlow;
